/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';

import BaseComponent from './panther/components/base/BaseComponent';
import Logger from './panther/core/Logger';
import classNames from 'classnames';

import MicrositeNavBar from './views/components/MicrositeNavBar/MicrositeNavBar';
import MicrositePage from './views/components/MicrositePage/MicrositePage';

import UrlStateStore from './stores/UrlStateStore';
import 'rc-checkbox/assets/index.css';
import 'rc-radio/assets/index.css';
import 'rc-select/assets/index.css';

import style from './Microsite.css';
import Footer from "./views/components/Pucs/Footer";

let data = require('./data.json');

function getAppState() {
    return UrlStateStore.getState();
    }

class Microsite extends BaseComponent {
    constructor(props){
        super(props);
        this.onViewChange = this.onViewChange.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.state = {
            scrolled: false,
            view: "page"
        }
    }

    componentDidMount () {
        UrlStateStore.addEventListener('VIEW_CHANGE', this.onViewChange);
        window.addEventListener('scroll', this.onScroll);
        this.onViewChange();
    }

    componentWillUnmount () {
        UrlStateStore.removeEventListener('VIEW_CHANGE', this.onViewChange);
        window.removeEventListener('scroll', this.onScroll);
    }

    onViewChange(){
        let stateFromStore = getAppState();
        this.setState(stateFromStore);
    }

    onScroll(event){
        let scrollTop = event.srcElement ? event.srcElement.body.scrollTop : event.pageY;
        if (scrollTop === 0){
            scrollTop = document.documentElement.scrollTop; // fix for IE 11
        }

        if (scrollTop > 10){
            this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    }

    render() {
        if (!data){
            Logger.error("data.json file is missing!")
        }
        if (!data.intro){
            Logger.error("intro property is missing in data.json!")
        }
        if (!data.sections){
            Logger.error("sections property is missing in data.json!")
        }

        let intro = data.intro;
        let sections = data.sections;
        let footer = data.footer;

        let classes = classNames(
            '', {
                'page-mode': this.state.view === "page",
                'map-mode': this.state.view === "map",
            },
            this.props.className
        );

        return (
            <div id="microsite" className={classes}>
                <MicrositeNavBar
                    intro={intro}
                    sections={sections}
                    scrolled={this.state.scrolled}
                />
                <MicrositePage
                    intro={intro}
                    sections={sections}
                    footer={footer}
                />
            </div>
        );
    }
}

export default Microsite;
